import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { WORKFLOW_BASE } from "../workflow/workflowRoutes";

/**
 * Legacy `/` entry. The 6-step workflow is now URL-routed under
 * /workflow/<slug> (see App.js routes → WorkflowLayout + pages/steps/*).
 * This redirects into the workflow, preserving any deep-link query
 * string (?calc_id) so Client-History links keep working.
 *
 * v0.6 nav refactor Phase 2 — the Step 2–6 section components previously
 * exported from here have been migrated to their own route files
 * (pages/steps/Step2Configure.jsx … Step6Freeze.jsx) and the strangler
 * shim removed.
 */
export default function Dashboard() {
  const loc = useLocation();
  // A2-581 lead 9: AuthGate's "that page is admin-only" travels on, so the
  // workflow can say it (it was dropped here: the click just bounced back).
  return <Navigate to={{ pathname: WORKFLOW_BASE, search: loc.search }} state={loc.state} replace />;
}
